import React from 'react';
import { useTranslate } from 'react-admin';
import { Form, InputNumber } from 'antd';
import { Box, IconButton, makeStyles, Tooltip } from '@material-ui/core';
import { Refresh } from '@material-ui/icons';

const MonthlyRoyaltyInput = ({ defaultRoyalty, disabled }) => {
  const t = useTranslate();

  return (
    <Form.Item
      name="monthlyRoyalty"
      rules={[
        ({ getFieldValue }) => ({
          validator() {
            const value = getFieldValue('monthlyRoyalty');

            if (value < 0 || value === 0) {
              return Promise.reject(
                new Error(
                  t('ra.validation.greater', {
                    min: 0,
                  }),
                ),
              );
            }

            if (value > 100) {
              return Promise.reject(
                new Error(
                  t('ra.validation.maxValue', {
                    max: 100,
                  }),
                ),
              );
            }

            return Promise.resolve();
          },
        }),
      ]}
      disabled={disabled}
    >
      <RoyaltyInput defaultRoyalty={defaultRoyalty} placeholder={t('resources.brand.monthlyRoyaltyPlaceholder')} />
    </Form.Item>
  );
};

export default MonthlyRoyaltyInput;

export const RoyaltyInput = ({ onChange, defaultRoyalty, ...props }) => {
  const classes = useStyles();
  const t = useTranslate();

  const handleKeyDown = (e) => {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
    const isCtrlCommand = e.ctrlKey || e.metaKey;

    if (allowedKeys.includes(e.key) || (isCtrlCommand && ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase()))) {
      return;
    }

    const char = e.key;

    if (!/[\d.]/.test(char)) {
      e.preventDefault();
      return;
    }

    const input = e.target.value;
    const [, decimalPart = ''] = input.split('.');
    const { selectionStart } = e.target;

    if (char === '.' && input.includes('.')) {
      e.preventDefault();
      return;
    }

    if (input.includes('.') && selectionStart > input.indexOf('.')) {
      if (decimalPart.length >= 2) {
        e.preventDefault();
      }
    }
  };

  const parseValue = (displayValue) => {
    const value = parseFloat(displayValue);
    return Number.isNaN(value) ? undefined : value;
  };

  return (
    <InputNumber
      suffix="%"
      size="small"
      onChange={(value) => onChange(parseValue(value))}
      className={classes.input}
      onKeyDown={handleKeyDown}
      controls={false}
      stringMode
      parser={parseValue}
      addonAfter={
        defaultRoyalty && (
          <Tooltip
            title={t('resources.brand.resetToDefault', {
              value: defaultRoyalty,
            })}
          >
            <Box
              component={IconButton}
              size="small"
              color="primary"
              sx={{
                width: 'fit-content',
              }}
              onClick={() => onChange?.(defaultRoyalty)}
            >
              <Refresh fontSize="small" />
            </Box>
          </Tooltip>
        )
      }
      {...props}
    />
  );
};

const useStyles = makeStyles({
  input: {
    paddingInlineStart: 0,
    minWidth: 160,
  },
});
